import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  SimpleGrid,
  Box,
  Input,
  FormLabel,
  Select,
  InputGroup,
  InputLeftAddon,
  useDisclosure,
  Checkbox,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import axios from "axios";
import { useNcContext } from "../context/ncContext";

import toast from "react-hot-toast";
import { set } from "lodash";

const NcPopup = ({ isOpen, onClose, id, onOpen, customerId, tableNo }) => {
  const { postNc } = useNcContext();

  const [name, setName] = useState("");
  const [nc, setNc] = useState([]);

  const ncData = async () => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getNc/${customerId}`,
      );
      setNc(response.data.nc);
    } catch (error) {}
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0]; // Extracts the YYYY-MM-DD part
  };
  const handleAdd = () => {
    if (name) {
      postNc(customerId, tableNo, name);
      toast.success("Nc Added Successfully");
      onClose();
    } else {
      toast.error("Please enter a name");
    }
  };

  useEffect(() => {
    ncData();
  }, [customerId]);

  const scroll = "inside";

  const handleClick = () => {
    onClose();
  };
  return (
    <Modal
      width="full"
      size="md"
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      scrollBehavior={scroll}
    >
      <ModalOverlay />
      <ModalContent bg="#f9f1e3">
        <ModalHeader
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Text>NC Data</Text>
          <Button colorScheme="red" onClick={handleClick}>
            <IoMdClose />
          </Button>
        </ModalHeader>

        <ModalBody>
          <Box textAlign="center">
            <Select
              width="70%"
              placeholder="Enter Name"
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            >
              {nc?.map((item, index) => (
                <option key={index} value={item._id}>
                  {item.name}
                </option>
              ))}
            </Select>
          </Box>
          <SimpleGrid columns={2} gap={4} placeItems="left"></SimpleGrid>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={4}
            mt={2}
          >
            <Button colorScheme="blue" onClick={handleAdd}>
              Add
            </Button>
          </Box>
        </ModalBody>

        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default NcPopup;
